import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43d3d4df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-6px","margin-right":"-10px"} }
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "cm", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "cm", -1))
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "cm", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "cm", -1))
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "cm", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "cm", -1))
const _hoisted_19 = ["title"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_21 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_22 = ["title"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "KGS", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "KGS", -1))
const _hoisted_25 = ["title"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_27 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_28 = ["title"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "CBM", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "CBM", -1))
const _hoisted_31 = ["title"]
const _hoisted_32 = ["title"]
const _hoisted_33 = ["title"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_35 = ["title"]
const _hoisted_36 = ["title"]
const _hoisted_37 = { style: {"clear":"both","margin-top":"30px"} }
const _hoisted_38 = { style: {"float":"left"} }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 0,
  style: {"float":"left","width":"100%","font-size":"14px","color":"red"}
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0px","text-align":"center","margin":"0px","padding-left":"20px","padding-right":"20px"} }, " KGS ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0px","text-align":"center","margin":"0px","padding-left":"20px","padding-right":"20px"} }, " KGS ", -1))
const _hoisted_44 = { key: 0 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0px","text-align":"center","margin":"0px","padding-left":"20px","padding-right":"20px"} }, " m³ ", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0px","text-align":"center","margin":"0px","padding-left":"20px","padding-right":"20px"} }, " m³ ", -1))
const _hoisted_47 = { style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "装货港出库货量", -1))
const _hoisted_49 = { style: {"clear":"both","height":"30px","overflow":"hidden"} }
const _hoisted_50 = { style: {"clear":"both","height":"25px","padding-top":"3px","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.ruleForm.Visible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ruleForm.Visible) = $event)),
      top: _ctx.isSelectClientCompany==true?'50px':'20px',
      "show-close": false,
      style: _normalizeStyle(_ctx.isSelectClientCompany==true?'width: 50%':'width: 96%' ),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isSelectClientCompany == true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "添加"))
            : (_ctx.isDetail==true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "计划货量"))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "编辑计划货量"))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.isSelectClientCompany == true)
          ? (_openBlock(), _createBlock(_component_miezz_form, {
              ref: "$addRuleForm",
              modelValue: _ctx.addRuleForm,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addRuleForm) = $event)),
              fix: true,
              key: _ctx.clientRandom
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'ClientCompanyId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.addRuleForm.Data.ClientCompanyId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addRuleForm.Data.ClientCompanyId) = $event)),
                          filterable: "",
                          placeholder: "请选择",
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeClientCompanyId()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientCompanys, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.Value,
                                label: item.Label,
                                value: item.Value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'OrderPoolId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: item.Prop,
                      label: "Booking No"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.addRuleForm.Data.OrderPoolId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addRuleForm.Data.OrderPoolId) = $event)),
                          disabled: _ctx.addRuleForm.Data.ClientCompanyId!=null && _ctx.addRuleForm.Data.ClientCompanyId!=undefined?false:true
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pools, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.Value,
                                label: item.Label,
                                value: item.Value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "disabled"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.isSelectClientCompany == false)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              ref: "ruleFormPlan",
              model: _ctx.item,
              "label-width": "150px",
              rules: _ctx.customsPackageTableRules
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_table, {
                    ref: "customsPackageTable",
                    data: _ctx.item.Data.Items,
                    "max-height": _ctx.widthHeight,
                    onSelectionChange: _ctx.handleSelectionChange
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 0,
                            type: "selection",
                            width: "55"
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_table_column, {
                        type: "index",
                        label: "序号",
                        width: "80"
                      }),
                      (_ctx.type!=20)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 1,
                            prop: "ProductName",
                            label: "产品名称"
                          }, {
                            default: _withCtx((scope) => [
                              (scope.row.PackageZh)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    style: {"width":"100% !important","word-break":"break-all","overflow":"hidden","height":"26px","line-height":"26px"},
                                    title: scope.row.ProductName
                                  }, _toDisplayString(_ctx.isString(scope.row.ProductName)), 9, _hoisted_7))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_table_column, { prop: "Leng" }, {
                        header: _withCtx(() => [
                          _createVNode(_component_miezz_text_ellipsis, {
                            text: 'L/φ（长度（最长边）/直径）（cm）',
                            tooltip: true,
                            className: 'Leng'
                          })
                        ]),
                        default: _withCtx((scope) => [
                          (_ctx.isDetail!=true)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                                title: scope.row.Length
                              }, [
                                (scope.row.IsSelected == true)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      "label-width": "0px",
                                      prop: 'Data.Items.' + scope.$index + '.Length',
                                      rules: _ctx.customsPackageTableRules.Length,
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: false,
                                          modelValue: scope.row.Length,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Length) = $event),
                                          onBlur: ($event: any) => (_ctx.onChangeLength(scope.$index))
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_9
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]))
                                  : (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      "label-width": "0px",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: true,
                                          modelValue: scope.row.Length,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Length) = $event)
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_10
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024))
                              ], 8, _hoisted_8))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                title: scope.row.Length
                              }, _toDisplayString(_ctx.isString(scope.row.Length)), 9, _hoisted_11))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { prop: "Width" }, {
                        header: _withCtx(() => [
                          _createVNode(_component_miezz_text_ellipsis, {
                            text: 'W/φ（宽度（第二长边）/直径）（cm）',
                            tooltip: true,
                            className: 'Width'
                          })
                        ]),
                        default: _withCtx((scope) => [
                          (_ctx.isDetail!=true)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                                title: scope.row.Width
                              }, [
                                (scope.row.IsSelected == true)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      "label-width": "0px",
                                      prop: 'Data.Items.' + scope.$index + '.Width',
                                      rules: _ctx.customsPackageTableRules.Width,
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: false,
                                          modelValue: scope.row.Width,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Width) = $event),
                                          onBlur: ($event: any) => (_ctx.onChangeWidth(scope.$index))
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_13
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]))
                                  : (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      "label-width": "0px",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: true,
                                          modelValue: scope.row.Width,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Width) = $event)
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_14
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024))
                              ], 8, _hoisted_12))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                title: scope.row.Width
                              }, _toDisplayString(_ctx.isString(scope.row.Width)), 9, _hoisted_15))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { prop: "Height" }, {
                        header: _withCtx(() => [
                          _createVNode(_component_miezz_text_ellipsis, {
                            text: 'H（高度/最短边）（cm）',
                            tooltip: true,
                            className: 'Height'
                          })
                        ]),
                        default: _withCtx((scope) => [
                          (_ctx.isDetail!=true)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                                title: scope.row.Height
                              }, [
                                (scope.row.IsSelected == true)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      "label-width": "0px",
                                      prop: 'Data.Items.' + scope.$index + '.Height',
                                      rules: _ctx.customsPackageTableRules.Height,
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: false,
                                          modelValue: scope.row.Height,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Height) = $event),
                                          onBlur: ($event: any) => (_ctx.onChangeHeight(scope.$index))
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_17
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]))
                                  : (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      "label-width": "0px",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: true,
                                          modelValue: scope.row.Height,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Height) = $event)
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_18
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024))
                              ], 8, _hoisted_16))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                title: scope.row.Height
                              }, _toDisplayString(_ctx.isString(scope.row.Height)), 9, _hoisted_19))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { prop: "GrossWeight" }, {
                        header: _withCtx(() => [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_miezz_text_ellipsis, {
                              text: '单件毛重KGS',
                              tooltip: true,
                              className: 'GrossWeight'
                            })
                          ])
                        ]),
                        default: _withCtx((scope) => [
                          (_ctx.isDetail!=true)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                                title: scope.row.GrossWeight
                              }, [
                                (scope.row.IsSelected == true)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      "label-width": "0px",
                                      label: "",
                                      prop: 'Data.Items.' + scope.$index + '.GrossWeight',
                                      rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: false,
                                          modelValue: scope.row.GrossWeight,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.GrossWeight) = $event),
                                          onBlur: ($event: any) => (_ctx.onChangeGrossWeight(scope.$index))
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_23
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"]))
                                  : (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      "label-width": "0px",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: true,
                                          modelValue: scope.row.GrossWeight,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.GrossWeight) = $event)
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_24
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024))
                              ], 8, _hoisted_22))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                title: scope.row.GrossWeight
                              }, _toDisplayString(_ctx.isString(scope.row.GrossWeight)), 9, _hoisted_25))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Volume",
                        label: "单件体积CBM",
                        width: "230px"
                      }, {
                        header: _withCtx(() => [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_miezz_text_ellipsis, {
                              text: '单件体积CBM',
                              tooltip: true,
                              className: 'Volume'
                            })
                          ])
                        ]),
                        default: _withCtx((scope) => [
                          (_ctx.isDetail!=true)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                                title: scope.row.Volume
                              }, [
                                (scope.row.IsSelected == true)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      "label-width": "0px",
                                      label: "",
                                      prop: 'Data.Items.' + scope.$index + '.Volume',
                                      rules: _ctx.customsPackageTableRules.Volume
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: (scope.row.Length!=undefined && scope.row.Width!=undefined && scope.row.Height!=undefined)?true:false,
                                          modelValue: scope.row.Volume,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Volume) = $event),
                                          onBlur: ($event: any) => (_ctx.onChangeVolume(scope.$index))
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_29
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onBlur"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]))
                                  : (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      "label-width": "0px",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: true,
                                          modelValue: scope.row.Volume,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Volume) = $event)
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_30
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024))
                              ], 8, _hoisted_28))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                title: scope.row.Volume
                              }, _toDisplayString(_ctx.isString(scope.row.Volume)), 9, _hoisted_31))
                        ]),
                        _: 1
                      }),
                      (_ctx.orderDepartureWharfId!=null&&_ctx.orderDepartureWharfId!=undefined&&_ctx.orderDepartureWharfId!='' || _ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 2,
                            prop: "Quantity",
                            label: "数量"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                title: scope.row.Quantity
                              }, _toDisplayString(_ctx.isString(scope.row.Quantity)), 9, _hoisted_32)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.orderDepartureWharfId!=null&&_ctx.orderDepartureWharfId!=undefined&&_ctx.orderDepartureWharfId!='' || _ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 3,
                            prop: "SurplusQuantity",
                            label: "剩余数量"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                title: scope.row.SurplusQuantity
                              }, _toDisplayString(scope.row.SurplusQuantity), 9, _hoisted_33)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_table_column, {
                        prop: "DeliveryQuantity",
                        label: "送货数量"
                      }, {
                        header: _withCtx(() => [
                          _hoisted_34,
                          _createTextVNode(" 送货数量 ")
                        ]),
                        default: _withCtx((scope) => [
                          (_ctx.isDetail!=true)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                                title: scope.row.DeliveryQuantity
                              }, [
                                (scope.row.IsSelected == true)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      "label-width": "0px",
                                      label: "",
                                      prop: 'Data.Items.' + scope.$index + '.DeliveryQuantity',
                                      rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: _ctx.item.Data.IsShiftout!=true?false:true,
                                          modelValue: scope.row.DeliveryQuantity,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.DeliveryQuantity) = $event),
                                          onBlur: ($event: any) => (_ctx.onChangeDeliveryQuantity(scope.$index))
                                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onBlur"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"]))
                                  : (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      "label-width": "0px",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: true,
                                          modelValue: scope.row.DeliveryQuantity,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.DeliveryQuantity) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024))
                              ], 8, _hoisted_35))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                title: scope.row.DeliveryQuantity
                              }, _toDisplayString(scope.row.DeliveryQuantity), 9, _hoisted_36))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "max-height", "onSelectionChange"])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_el_row, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          (_ctx.isDetail != true)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: "合计件数",
                                prop: "Data.SumQuantity",
                                rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.item.Data.SumQuantity,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.Data.SumQuantity) = $event)),
                                    disabled: (_ctx.item.Data.Items!=null && _ctx.item.Data.Items.length>0)?true:false,
                                    class: "input-with-select",
                                    onBlur: _ctx.onChangeSumQuantity
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.item.Data.ChargeUnit,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.Data.ChargeUnit) = $event)),
                                        style: {"width":"100% !important","background-color":"#fff"},
                                        filterable: "",
                                        "allow-create": "",
                                        "default-first-option": "",
                                        "reserve-keyword": false,
                                        placeholder: "请选择"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageEnHistorys, (item, index) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.Label,
                                              label: item.Label,
                                              value: item.Label
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_38, _toDisplayString(item.Label), 1),
                                                (item.Data.IsHistory==true)
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 0,
                                                      style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"},
                                                      onClick: ($event: any) => (_ctx.onDeletePackageEn(item.Value,index))
                                                    }, [
                                                      _createVNode(_component_el_icon, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_Delete)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ], 8, _hoisted_39))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1032, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled", "onBlur"]),
                                  (_ctx.isQuantity == true)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, " 合计送货数量不能大于总数量 "))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                label: "合计件数"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.item.Data.SumQuantity) + _toDisplayString(_ctx.item.Data.ChargeUnit), 1)
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          (_ctx.isDetail != true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                (_ctx.selectRowCount>0)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      label: "合计毛重",
                                      prop: "Data.SumGrossWeight",
                                      rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.item.Data.SumGrossWeight,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.Data.SumGrossWeight) = $event)),
                                          onBlur: _ctx.onChangeSumGrossWeight,
                                          disabled: (_ctx.item.Data.Items!=null && _ctx.item.Data.Items.length>0)?true:false
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_42
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "onBlur", "disabled"])
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      label: "合计毛重",
                                      prop: "Data.SumGrossWeight"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.item.Data.SumGrossWeight,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.Data.SumGrossWeight) = $event)),
                                          onBlur: _ctx.onChangeSumGrossWeight,
                                          disabled: (_ctx.item.Data.Items!=null && _ctx.item.Data.Items.length>0)?true:false
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_43
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "onBlur", "disabled"])
                                      ]),
                                      _: 1
                                    }))
                              ]))
                            : (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                label: "合计毛重"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.item.Data.SumGrossWeight) + "KGS ", 1)
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          (_ctx.isDetail != true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                (_ctx.selectRowCount>0)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      label: "合计体积",
                                      prop: "Data.SumVolume",
                                      rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.item.Data.SumVolume,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.Data.SumVolume) = $event)),
                                          onBlur: _ctx.onChangeSumVolume,
                                          disabled: (_ctx.item.Data.Items!=null && _ctx.item.Data.Items.length>0)?true:false
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_45
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "onBlur", "disabled"])
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 1,
                                      label: "合计体积",
                                      prop: "Data.SumVolume"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.item.Data.SumVolume,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.Data.SumVolume) = $event)),
                                          onBlur: _ctx.onChangeSumVolume,
                                          disabled: (_ctx.item.Data.Items!=null && _ctx.item.Data.Items.length>0)?true:false
                                        }, {
                                          append: _withCtx(() => [
                                            _hoisted_46
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "onBlur", "disabled"])
                                      ]),
                                      _: 1
                                    }))
                              ]))
                            : (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                label: "合计体积"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.item.Data.SumVolume) + "m³ ", 1)
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true),
        (_ctx.plan.Data.IsDepartureOutStock == true )
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 2,
              style: {"margin-top":"20px"}
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", {
                    style: {"float":"right","cursor":"pointer","font-weight":"400","color":"#fe995b"},
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onDepartureDetail()))
                  }, " 查看详情 ")
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_el_row, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计件数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.plan.Data.SumQuantityOutStock) + _toDisplayString(_ctx.plan.Data.ChargeUnitOutStock), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计毛重" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.plan.Data.SumGrossWeightOutStock) + "KGS ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计体积" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.plan.Data.SumVolumeOutStock) + "m³ ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_50, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.bottomButtons,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.bottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClick
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "top", "style"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}